module.exports = __webpack_public_path__ + "static/media/OrthoInative.a8621505.png";